import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import dayjs from "dayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import { AssignStreamTag } from "../../DAL/create";
import { updateAssignTagsData } from "../../DAL/update";
import { enqueueSnackbar } from "notistack";

export default function AssignTagDialog({ open, setOpen, data, type }) {
  const [value, setValue] = React.useState(dayjs());
  const [inputs, setInputs] = useState({
    userCode: "",
    streamTagId: "",
    isExpired: "",
  });
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const momentDate = moment(value);

    const formatted = `${momentDate.format(
      "YYYY-MM-DD HH:mm:ss"
    )}.${momentDate.format("SSSSSS")}+08`;
    const formData = {
      userCode: inputs?.userCode,
      streamTagId: inputs?.streamTagId,
      expiredAt: formatted,
    };

    const formDataUpdate = {
      ...formData,
      isExpired: Boolean(inputs?.isExpired),
    };

    const resp =
      type == "Add"
        ? await AssignStreamTag(formData)
        : await updateAssignTagsData(data?.id, formDataUpdate);
    if (
      type == "Add"
        ? resp?.data?.statusCode == 201
        : resp?.data?.statusCode == 200
    ) {
      enqueueSnackbar(resp?.data?.message || resp?.message, {
        variant: "success",
      });
      setOpen(false);
    } else {
      enqueueSnackbar(
        resp?.message ||
          resp?.error ||
          resp?.data?.message ||
          resp?.data?.error,
        { variant: "error" }
      );
    }
  };

  useEffect(() => {
    if (open && data) {
      setInputs((prev) => ({
        ...prev,
        streamTagId: type == "Add" ? data.id : data?.streamTag?.id,
        userCode: type == "Add" ? "" : data?.assignedUser?.code,
      }));
      if (type == "Update") {
        setValue(dayjs(data.expiredAt));
      }
    }
  }, [open, data]);
  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      BackdropProps={{
        sx: {
          backdropFilter: "blur(4px)",
          backgroundColor: "rgba(0, 0, 0, 0.2)",
        },
      }}
    >
      <DialogContent sx={{ width: 500 }}>
        <DialogTitle id="alert-dialog-title">
          {type == "Update" ? "Update Assign tag" : "Assign Tag"}
        </DialogTitle>
        <div>
          <TextField
            label="User RID"
            name="userCode"
            value={inputs?.userCode}
            onChange={handleChange}
            fullWidth
            size="small"
          />
        </div>
        <div style={{ marginTop: "10px" }}>
          <TextField
            label="Tag ID"
            name="streamTagId"
            value={inputs?.streamTagId}
            onChange={handleChange}
            fullWidth
            size="small"
          />
        </div>
        {type == "Update" && (
          <div style={{ marginTop: "10px" }}>
            <FormControl fullWidth size="small">
              <InputLabel id="demo-simple-select-label">Is Expired</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={inputs?.isExpired}
                name="isExpired"
                label="Is Expired"
                onChange={handleChange}
              >
                <MenuItem value={true}>True</MenuItem>
                <MenuItem value={false}>False</MenuItem>
              </Select>
            </FormControl>
          </div>
        )}
        <div style={{ marginTop: "10px" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimePicker
              label="Select Date & Time"
              value={value}
              onChange={(newValue) => setValue(newValue)}
              renderInput={(params) => <TextField {...params} fullWidth />}
            />
          </LocalizationProvider>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setOpen(false)}
          color="primary"
          variant="outlined"
          sx={{ borderRadius: "10px", textTransform: "none" }}
        >
          Cancel
        </Button>
        <Button
          className="gradientButton"
          autoFocus
          variant="contained"
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}
